import { render } from "./register-three.vue?vue&type=template&id=b5a67f62"
import script from "./register-three.vue?vue&type=script&lang=js"
export * from "./register-three.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__